// Smart Daara - Console IA super admin (interrupteur global + activation par école)
import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { aiAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Switch } from '../../components/ui/switch';
import { Badge } from '../../components/ui/badge';
import { Sparkles } from 'lucide-react';
import { toast } from 'sonner';

export default function AIAdminGlobal() {
  const { language } = useLanguage();
  const fr = language === 'fr';
  const [data, setData] = useState(null);
  const load = () => aiAPI.getGlobal().then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!data) return <div className="flex justify-center p-12"><div className="animate-spin w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full" /></div>;

  return (
    <div className="space-y-6" data-testid="ai-admin-global-page">
      <h1 className="text-2xl font-outfit font-bold text-slate-900 flex items-center gap-2">
        <Sparkles className="w-6 h-6 text-emerald-600" />{fr ? 'IA — Plateforme' : 'AI — Platform'}
      </h1>
      <Card className="border-0 shadow-sm">
        <CardContent className="p-5 flex items-center justify-between">
          <div>
            <p className="font-medium">{fr ? 'Interrupteur IA global' : 'Global AI switch'}</p>
            <p className="text-xs text-slate-400">{fr ? 'Si OFF, toutes les fonctions IA sont masquées partout.' : 'When OFF, all AI features are hidden everywhere.'}</p>
          </div>
          <Switch checked={data.global.enabled} data-testid="ai-global-switch" onCheckedChange={async (v) => {
            try {
              await aiAPI.updateGlobal({ enabled: v }); load();
              toast.success(v ? 'IA activée' : 'IA désactivée');
            } catch { toast.error(fr ? 'Erreur lors de la mise à jour' : 'Update failed'); }
          }} />
        </CardContent>
      </Card>
      <Card className="border-0 shadow-sm">
        <CardHeader><CardTitle className="text-base">{fr ? 'Activation par école' : 'Per-school activation'}</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {data.schools.length === 0 && <p className="text-slate-400 text-sm">{fr ? 'Aucune école.' : 'No schools.'}</p>}
          {data.schools.map((s) => (
            <div key={s.tenant_id} className="flex items-center justify-between px-3 py-2 bg-slate-50 rounded-lg">
              <span className="font-medium">{s.tenant_name}</span>
              <Switch checked={!!s.enabled} data-testid={`ai-school-switch-${s.tenant_id}`} onCheckedChange={async (v) => {
                try { await aiAPI.updateSchoolBySuper(s.tenant_id, { enabled: v }); load(); }
                catch { toast.error(fr ? 'Erreur lors de la mise à jour' : 'Update failed'); }
              }} />
            </div>
          ))}
        </CardContent>
      </Card>
      <Card className="border-0 shadow-sm">
        <CardHeader><CardTitle className="text-base">{fr ? 'Consommation' : 'Usage'}</CardTitle></CardHeader>
        <CardContent>
          <p className="text-sm">{fr ? 'Coût total estimé' : 'Estimated total cost'} : <b>${data.total_cost_usd}</b> / ${data.global.monthly_budget_usd} {fr ? 'budget mensuel' : 'monthly budget'}</p>
          <div className="mt-2 space-y-1 max-h-60 overflow-y-auto">
            {data.usage_recent.map((u, i) => (
              <p key={i} className="text-xs text-slate-500">{u.function} · {u.role} · {u.tokens} tokens · ${u.cost_usd}</p>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
